module.exports = {
  siteTitle: 'Lastbit Hardware', // <title>
  manifestName: 'Lastbit Hardware',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/lastbit/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  heading: 'Lastbit Hardware',
  subHeading:
    'Refining the norms in digital asset security with easy to use, portable hardware.',
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: '',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: '',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: '',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: '',
    },
  ],
};
